import { Button } from "../PSY/Button"

import { useLiquity } from "../../hooks/LiquityContext";
import { useTransactionFunction } from "../Transaction";

type ApproveActionProps = {
  transactionId: string;
  disabled: boolean
  assetAddress: string
};

export const ApproveAction: React.FC<ApproveActionProps> = ({
  children,
  transactionId,
  disabled,
  assetAddress,
}) => {
  const { liquity } = useLiquity();

  const [sendTransaction] = useTransactionFunction(
    transactionId,
    liquity.send.approveAsset.bind(liquity.send, assetAddress, undefined, undefined)
  );

  return <Button onSubmit={sendTransaction} disabled={disabled} className="flex flex-1">{children}</Button>;
};
